export const capitalizeFirstLetter = (value?: string): string => {
	if (!value || typeof value !== "string") {
		return "";
	}
	return value.charAt(0).toUpperCase() + value.slice(1);
};
export const lowercaseFirstLetter = (string: string) => string.charAt(0).toLowerCase() + string.slice(1);
